export var VerifyTokenType;
(function (VerifyTokenType) {
    VerifyTokenType[VerifyTokenType["Confirm"] = 0] = "Confirm";
    VerifyTokenType[VerifyTokenType["Reset"] = 1] = "Reset";
})(VerifyTokenType || (VerifyTokenType = {}));
